import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { Select, message, DatePicker } from 'antd';
import {
  Tooltip,
  UncontrolledTooltip,
  Modal,
  ModalHeader,
  ModalBody,
  Button,
  ButtonGroup,
  FormGroup,
  Input as InputBox,
  Col,
  Row,
  ModalFooter,
  Label,
} from 'reactstrap';
import LoadingComponent from '../common/LoadingComponent';
import PenButton from '../../images/PenButton.svg';
import TickButton from '../../images/TickButton.svg';
import CrossButton from '../../images/CrossButton.svg';
import DocsButton from '../../images/DocsButton.svg';
import TimerButton from '../../images/TimerButton.svg';
import MarkAsStuck from '../../images/markAsStuck.svg';
import SomeButton from '../../images/SomeButton.svg';
import DropDown from '../../images/DropDown.svg';
import ClaimRequest from '../../images/ClaimRequest.svg';
import AddAssignee from '../../images/AddAssignee.svg';
import ApiBooking from '../../images/ApiBooking.svg';
import AlternateSuggestions from '../../images/AlternateSuggestions.svg';
import ShiftToReimbursement from '../../images/ShiftToReimbursement.svg';
import ShiftToPending from '../../images/ShiftToPending.svg';
import RequestReconfirmation from '../../images/RequestReconfirmation.svg';
import GrowthArrow from '../../images/GrowthArrow.svg';
import MarkFollowUp from '../../images/MarkFollowUp.svg';
import Reimbursement from '../../images/Reimbursement.svg';
import Pending from '../../images/Pending.svg';
import Communications from '../../images/Communications.svg';
import PrebookUserConfirm from '../../images/PrebookUserConfirm.svg';
import PrebookCenterConfirm from '../../images/PrebookCenterConfirm.svg';
import OfflineModalConfirm from './OfflineModalConfirm';
import FollowUpModal from './FollowUpModal';
import EditDoctorSlots from './EditDoctorSlots';
import {
  getAllOfflineRequestsCount,
  sendPriceChangeRequestAPI,
  confirmRequest,
  cancelRequest,
  shiftOfflineConsultationToReimbursement,
  requestReconfirmationForOfflineConsult,
  placeRequest,
  fetchCancelledReasons,
  getAllOfflineRequests,
  markFollowUp,
  shiftOfflineConsultationStatusToPending,
  markRequestAsStuck,
  updatePrebookStatus,
  shiftAppointment,
  searchDoctors
} from '../../services/api/offline-consult';
import {
  showRequestModal,
  hideRequestModal,
  hideDoctorSlotsEditModal,
  showDoctorSlotsEditModal,
  //   showInternalComments,
  hideInternalComments,
  updateRequestID,
} from '../../actions/index';
import OfflineModalCancel from './OfflineModalCancel';
import RescheduleAppointMentRequest from './RescheduleAppointMentRequest';
import OfflineApiBookingModal from '../offline-consultations/OfflineApiBooking';
import ClaimRequestModal from './ClaimRequestModal';
import AddDoctorDetailModal from './AddDoctorDetailModal';
import PrebookUserConfirmedModal from './PrebookUserConfirmedModal';
import PrebookCenterConfirmedModal from './PrebookCenterConfirmedModal';
import SuggestionsDialog from './SuggestionsDialog';
import MarkEscallationModal from './MarkEscallationModal';
import CommunicationsSetup from './CommunicationSetup';
import StuckReuestModal from './StuckRequestModal';
import RescheduleAppointmentForApiHospitals from './RescheduleAppointmentForApiHospitals';
import moment from 'moment';
import OfflineModalClaimAndConfirm from './OfflineModalClaimAndConfirm';
import { Async } from 'react-select';

const Actions = ({
  requestData,
  requestId,
  priceApprovalStatus,
  onAction,
  editDoctorSlots,
  getOfflineRequestData,
  pre,
  requestData1,
  requestDataForConfirmFor,
  featureA,
  featureB,
  statusFilter,
  tagsFilter,
  appointmentStatus = 0
}) => {
  console.log({ requestData1 }, 'Actions-----');
  console.log({ requestId }, 'ActionsHJS');
  const [loading, setLoading] = useState(false);
  const [confirmModalIsOpen, setConfirmModalIsOpen] = useState(false);
  const [requestDataForConfirm, setRequestDataForConfirm] = useState(null);
  const [centerRequestStatus, setCenterRequestStatus] = useState(null);
  const [cancelModalIsOpen, setCancelModalIsOpen] = useState(false);
  const [showShiftingModal, setShowShiftingModal] = useState(false);
  const [showApiShiftingModal, setShowApiShiftingModal] = useState(false);
  const [showApiBookingModal, setShowApiBookingModal] = useState(false);
  const [shiftingDetails, setShiftingDetails] = useState(null);
  const [priceChangeRequestsModal, setPriceChangeRequestsModal] =
    useState(false);
  const [requestIdDataForPriceChange, setRequestIdDataForPriceChange] =
    useState(null);
  const [newPrice, setNewPrice] = useState('');
  const [priceChangeReason, setPriceChangeReason] = useState('');
  const [inputReason, setInputReason] = useState('');
  const [showClaimRequestModal, setShowClaimRequestModal] = useState(false);
  const [showClaimRequestModalRequestId, setShowClaimRequestModalRequestId] =
    useState(null);
  const [openActionDropDown, setOpenActionDropDown] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [addDoctorDetailModalOpen, setAddDoctorDetailModalOpen] =
    useState(false);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [suggestionsDetails, setSuggestionsDetails] = useState(null);
  const [shiftReimbursementModalOpen, setShiftReimbursementModalOpen] =
    useState(false);
  const [shiftToReimbursementReqId, setShiftToReimbursementReqId] =
    useState(null);
  const [requestReconfirmationModalOpen, setRequestReconfirmationModalOpen] =
    useState(false);
  const [requestReconfirmationRequestId, setRequestReconfirmationRequestId] =
    useState(null);
  const [prebookRequestDetails, setPrebookRequestDetails] =
    useState(null);
  const [showEscallationModal, setShowEscallationModal] = useState(false);
  const [escallationRequestId, setEscallationRequestId] = useState(null);
  const [followUpDetails, setFollowUpDetails] = useState(null);
  const [showFollowUpModal, setShowFollowUpModal] = useState(false);
  const [cancelledReasons, setCancelledReasons] = useState([]);
  const [subCancelledReasons, setSubCancelledReasons] = useState([]);

  const [shiftToPendingModalOpen, setShiftToPendingModalOpen] = useState(false);
  const [markAsStuckModalOpen, setMarkAsStuckModalOpen] = useState(false);
  const [markAsStuckRequestId, setMarkAsStuckRequestId] = useState(null);
  const [shiftToPendingRequestId, setShiftToPendingRequestId] = useState(null);
  const dispatch = useDispatch();
  const [openComms, setOpenComms] = useState(false);
  const [commsData, setCommsData] = useState(null);
  const [prebookUserConfirmModalOpen, setPrebookUserConfirmModalOpen] = useState(false);
  const [prebookCenterConfirmModalOpen, setPrebookCenterConfirmModalOpen] = useState(false);
  const [selfbookShiftingModalOpen, setSelfbookShiftingModalOpen] = useState(false);
  const [rescheduleDate, setRescheduleDate] = useState(null);
  const [rescheduleTime, setRescheduleTime] = useState(null);
  const [shifSelfbookLoader, setShiftSelfbookLoader] = useState(false);
  const [claimConfirmRequestModalOpen, setClaimConfirmRequestModalOpen] = useState(false);
  const [slotDetailsForClaimandConfirm, setSlotDetailsForClaimandConfirm] = useState({
    requestId: null,
    dateKey: null,
    slot: null,
    slotType: 'fixed',
    slotTimeRange: null,
  });
  const [doctorsData, setDoctorsData] = useState({});
  const [selfBookShiftingDetails, setSelfBookShiftingDetails] = useState(null);
  const { Option } = Select;

  const {
    // requestId,
    showEditDoctorSlots,
    doctorId,
    requestData: followUpData,
  } = useSelector((state) => state.offlineConsult);

  const {
    offlineAdmin
  } = useSelector((state) => state.user);

  console.log(followUpData, 'followUpData');
  const toggleDropdown = (dropdown) => {
    setOpenActionDropDown(dropdown);
    setIsOpen(!isOpen);
  };

  // useEffect(()=>{
  //   if(claimConfirmRequestModalOpen){
  //     setConfirmModalIsOpen(!claimConfirmRequestModalOpen);
  //   }
  // },[claimConfirmRequestModalOpen])

  const confirmOpenModal = (requestId, priceApprovalStatus, followUpData) => {
    if (priceApprovalStatus === 'Pending') {
      toast.error(
        'There is an active Price change request for this doctor. Please connect with network team. Until then you cannot confirm this appointment.'
      );
      return;
    }

    setConfirmModalIsOpen(true);

    //setRequestId(requestId);
    dispatch(updateRequestID(requestId));

    setRequestDataForConfirm(followUpData);
  };

  const claimConfirmRequestModalClose = () => {
    setClaimConfirmRequestModalOpen(false);
  }

  const claimConfirmRequestModalTrue = () => {
    setClaimConfirmRequestModalOpen(true);
  }

  console.log(confirmModalIsOpen, 'ConfirmModalIsOpen');

  const confirmCloseModal = () => {
    setConfirmModalIsOpen(false);
  };

  const cancelOpenModal = (requestId, priceApprovalStatus) => {
    if (priceApprovalStatus === 'Pending') {
      toast.error(
        'There is an active Price change request for this doctor. Please connect with network team. Until then you cannot cancel this appointment.'
      );
      return;
    }fetchCancelledReasons(requestId)
    .then((response) => {
      setCancelledReasons(response.cancelledReasons);
      setSubCancelledReasons(response.subCancelledReasons);
      
    })
    .catch(() => {
      setCancelledReasons([]);
      setSubCancelledReasons([]);
    });
    setCancelModalIsOpen(true);
    // setRequestId(requestId);
    dispatch(updateRequestID(requestId));
  };

  const cancelCloseModal = () => {
    setCancelModalIsOpen(false);
  };

  const openShiftingModal = (details) => {
    // console.log({ details, requestData }, 'openShiftingModal');
    if (details === undefined || details === null) {
      details = followUpData;
    }
    console.log({ details }, 'openShiftingModal');
    setShowShiftingModal(true);
    setShiftingDetails(details);
  };

  const openApiShiftingModal = (details) => {
    if (details === undefined || details === null) {
      details = followUpData;
    }
    console.log({ details }, 'openShiftingModal');
    setShowApiShiftingModal(true);
    setShiftingDetails(details);
  }

  const togglePriceChangeRequest = (requestIdData) => {
    console.log('Price Change Request', requestIdData);
    setPriceChangeRequestsModal(!priceChangeRequestsModal);
    setRequestIdDataForPriceChange(requestIdData);
    setNewPrice('');
    setPriceChangeReason('');
    setInputReason('');
  };

  const toggleShiftToReimbursementModal = (requestId) => {
    console.log('Shift to Reimbursement', requestId);
    setShiftReimbursementModalOpen(!shiftReimbursementModalOpen);
    setShiftToReimbursementReqId(
      typeof requestId === 'number' ? requestId : null
    );
  };

  const toggleSelfbookShiftingModal = (requestData) => {
    console.log('Selfbook Shifting Modal', requestData);
    setSelfBookShiftingDetails(requestData);
    setSelfbookShiftingModalOpen(!selfbookShiftingModalOpen);
  }

  const togglePrebookUserConfirmModal = (details) => {
    setPrebookUserConfirmModalOpen(!prebookUserConfirmModalOpen);
    setPrebookRequestDetails(details);
  };

  const togglePrebookCenterConfirmModal = (details) => {
    setPrebookCenterConfirmModalOpen(!prebookCenterConfirmModalOpen);
    setPrebookRequestDetails(details);
  };

  const toggleRequestReconfirmationModal = (requestId) => {
    console.log('toggleShiftToPendingModal', requestId);
    setRequestReconfirmationModalOpen(!requestReconfirmationModalOpen);
    setRequestReconfirmationRequestId(requestId);
  };

  const openClaimRequestButton = (requestId) => {
    setShowClaimRequestModal(true);
    setShowClaimRequestModalRequestId(requestId);
  };

  const onClaimRequestModalClose = () => {
    setShowClaimRequestModal(false);
    getAllOfflineRequests();
  };

  const onStuckRequestModalClose = () => {
    setMarkAsStuckModalOpen(false);
    getOfflineRequestData();
  };

  const openAddDoctorDetailModal = (details) => {
    console.log({ details }, 'open add Doctor Details modal');
    setAddDoctorDetailModalOpen(true);
  };

  const openApiBookingModal = (details) => {
    setShowApiBookingModal(true);
    setShiftingDetails(details);
  };

  const closeAddDoctorDetailModal = () => {
    setAddDoctorDetailModalOpen(false);
  };

  const openSuggestions = (details) => {
    console.log({ details }, 'openSuggestions');
    setShowSuggestions(true);
    setSuggestionsDetails(details);
  };

  const closeSuggestions = () => {
    setShowSuggestions(false);
    setSuggestionsDetails(null);
  };

  const shiftAppointmentToReimbursement = (requestId) => {
    setLoading(true);
    console.log(`Shifting to reimbursement ${requestId}`);
    shiftOfflineConsultationToReimbursement(requestId)
      .then((res) => {
        // Fetch consults
        if (res.message === 'success') {
          toast.success('Success');
          getAllOfflineRequests();
        } else {
          toast.error(res.errorMessage || 'Failed to Shift to reimbursement');
        }
      })
      .catch((err) => {
        console.log(err);
        toast.error(err.errorMessage || 'Failed to Shift to reimbursement');
      })
      .finally(() => {
        toggleShiftToReimbursementModal();
        setLoading(false);
      });
  };

  const shiftAppointmentToPending = (requestId) => {
    setLoading(true);
    console.log(`Change Status to pending ${requestId}`);
    shiftOfflineConsultationStatusToPending(requestId)
      .then((res) => {
        // Fetch consults
        if (res.message === 'success') {
          toast.success('Success');
          getAllOfflineRequests(); // make sure fetchTableData is defined in this scope
        } else {
          toast.error(res.errorMessage || 'Failed to Shift to Pending');
        }
      })
      .catch((err) => {
        console.log(err);
        if (err.response.data.errorMessage) {
          toast.error(err.response.data.errorMessage);
        } else {
          toast.error(err.errorMessage || 'Failed to Shift to Pending');
        }
      })
      .finally(() => {
        toggleShiftToPendingModal(shiftToPendingRequestId); // make sure toggleShiftToPendingModal is defined in this scope
        setLoading(false);
      });
  };

  const updatePrebookStatusRequest = (requestId, status) => {
    setLoading(true);
    updatePrebookStatus(requestId, { status })
      .then((res) => {
        // Fetch consults
        if (res.message === 'success') {
          toast.success('Success');
          getAllOfflineRequests(); // make sure fetchTableData is defined in this scope
        } else {
          toast.error(res.errorMessage || 'Failed to update prebook status');
        }
      })
      .catch((err) => {
        console.log(err);
        if (err.response.data.errorMessage) {
          toast.error(err.response.data.errorMessage);
        } else {
          toast.error(err.errorMessage || 'Failed to update prebook status');
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const markRequestAsStuckRequest = (requestId) => {
    setLoading(true);
    console.log(`mark request as stuck ${requestId}`);
    markRequestAsStuck(requestId)
      .then((res) => {
        // Fetch consults
        if (res.message === 'success') {
          toast.success('Success');
          getAllOfflineRequests(); // make sure fetchTableData is defined in this scope
        } else {
          toast.error(res.errorMessage || 'Failed to Mark as Stuck Request');
        }
      })
      .catch((err) => {
        console.log(err);
        if (err.response.data.errorMessage) {
          toast.error(err.response.data.errorMessage);
        } else {
          toast.error(err.errorMessage || 'Failed to Mark as Stuck Request');
        }
      })
      .finally(() => {
        toggleMarkAsStuckModal(markAsStuckRequestId); // make sure toggleMarkAsStuckModal is defined in this scope
        setLoading(false);
      });
  };

  const requestReconfirmationForConsultation = (requestId) => {
    setLoading(true);
    console.log('requestReconfirmationForConsultation', requestId);
    return requestReconfirmationForOfflineConsult(requestId)
      .then((resp) => {
        if (resp.message === 'success') {
          toast.success('Successfully Requested For Reconfirmation');
          // this.onFetchData();
        } else {
          toast.error(resp.errorMessage);
        }
      })
      .catch((err) => {
        console.log(err);
        toast.error('Something went wrong');
      })
      .finally(() => {
        setLoading(false);
        toggleRequestReconfirmationModal();
      });
  };

  const toggleShiftToPendingModal = (requestData) => {
    console.log('Shift tp pending---', requestData);
    setShiftToPendingModalOpen(prevState => !prevState);
    setShiftToPendingRequestId(requestId);
  };


  const handleDoctorSelection = (doctorsData) => {
    console.log(doctorsData, 'doctorsData123')
    setDoctorsData(doctorsData);
  };

  const searchDoctor = (val) => {
    console.log(selfBookShiftingDetails,requestData , 'searchDoctor');
    const centerId = selfBookShiftingDetails.networkCenterId || requestData.networkCenterId;
    const verticalId = selfBookShiftingDetails.verticalId || requestData.verticalId;
    return searchDoctors(val, verticalId, null, null, centerId)
      .then((response) => {
        return response.data || [];
      })
      .then((result) =>
        result.map((ele) => {
          return {
            label: `${ele.doctorName} - ${ele.networkCenterTitle} - ${ele.centerCity} - ${ele.networkSourceName}`,
            value: ele.doctorId,
            centerId: ele.networkCenterId,
            fees: ele.opdCharges,
            centerAddress: ele.centerAddress
          };
        })
      )
      .catch((err) => {
        console.log(err);
      });
  };

  const toggleMarkAsStuckModal = (requestData) => {
    console.log('mark as stuck---', requestData);
    setMarkAsStuckModalOpen(prevState => !prevState);
    setMarkAsStuckRequestId(requestId);
  };

  const openEscallationModal = (details) => {
    console.log({ details }, 'open escallation modal');
    setShowEscallationModal(true);
    setEscallationRequestId(details.requestId);
  };

  const closeEscallationModal = () => {
    setShowEscallationModal(false);
    setFollowUpDetails(null);
  };

  const closePrebookUserConfirmModal = () => {
    setPrebookRequestDetails(null);
    setPrebookUserConfirmModalOpen(false);
  };

  const closePrebookCenterConfirmModal = () => {
    setPrebookRequestDetails(null);
    setPrebookCenterConfirmModalOpen(false);
  };

  const openFollowUpModal = (details) => {
    console.log({ details }, 'open follow up modal');
    if (details === undefined || details === null) {
      details = followUpData;
    }
    setShowFollowUpModal(true);
    setFollowUpDetails(details);
  };

  const closeFollowUpModal = () => {
    setShowFollowUpModal(false);
    setFollowUpDetails(null);
  };

  // const toggleTooltip = (requestId) => {
  //   setSendCommunicationTooltipOpen(
  //     requestId === sendCommunicationTooltipOpen ? -1 : requestId
  //   );
  // };

  const openCommunications = (followUpData) => {
    console.log(followUpData, 'openCommunications---');
    setOpenComms(true);
    setCommsData(followUpData);
  };

  const closeCommunications = () => {
    setOpenComms(false);
  };

  const sendPriceChangeRequest = () => {
    setLoading(true);
    console.log(requestIdDataForPriceChange, 'requestIdDataForPriceChange');
    const params = {
      requestId: requestIdDataForPriceChange.requestId,
      centerId: requestIdDataForPriceChange.networkCenterId,
      doctorId: requestIdDataForPriceChange.doctorId,
      newPrice: newPrice,
      doctorName: requestIdDataForPriceChange.doctorName,
      centerName: requestIdDataForPriceChange.networkCenterName,
      fullfillmentType:
        requestIdDataForPriceChange.fullfillmentType || 'center',
      onBoardingStatus: requestIdDataForPriceChange.onBoardingStatus,
      priceChangeReason:
        priceChangeReason === 'Other' ? inputReason : priceChangeReason,
    };
    console.log('Price Change Request', params);
    return sendPriceChangeRequestAPI(params)
      .then((resp) => {
        if (resp.message === 'success') {
          toast.success('Successfully Requested For Price Change');
          // onFetchData();
        }
        toast.error(resp.errorMessage);
      })
      .catch((err) => {
        console.log(err);
        toast.error('Something went wrong');
      })
      .finally(() => {
        setLoading(false);
        togglePriceChangeRequest();
      });
  };

   const submitConfirmModal = (
    dateKey,
    slot,
    slotType = 'fixed',
    startAppointmentTime,
    endAppointmentTime
  ) => {
    const timeRange =
      startAppointmentTime && endAppointmentTime && slotType == 'walk-in'
        ? `${startAppointmentTime}-${endAppointmentTime}`
        : null;
    if (!requestId || !slot || !dateKey) {
      console.error({ requestId, dateKey, slot }, 'Params missing');
      return;
    }
    if (
      slotType == 'walk-in' &&
      !(startAppointmentTime || endAppointmentTime)
    ) {
      console.error(
        { startAppointmentTime, endAppointmentTime },
        'Params missing'
      );
      return;
    }
    return confirmRequest(
      requestId,
      dateKey,
      slot,
      centerRequestStatus,
      slotType,
      timeRange
    )
      .then((response) => {
        // Handle success response
        console.log({ response }, 'Confirm Response');
        if (
          response &&
          response.data &&
          response.data.message === 'serverError'
        ) {
          console.log('Server Error')
          toast.error(response.data.errorMessage);
        } else if (
          response &&
          response.message === 'invalid-ops-user'
        ){
          console.log("Invalid Ops User");
          setClaimConfirmRequestModalOpen(true)
          setConfirmModalIsOpen(false);
          setSlotDetailsForClaimandConfirm({
            requestId,
            dateKey,
            slot,
            slotType,
            timeRange
          })
          toast.error(response.errorMessage)
        } else {
          toast.success('Confirm Request Success');
          setConfirmModalIsOpen(false);
          onAction()
        }
      })
      .catch((err) => {
        // Error Handle
        if (err.response.data.errorMessage) {
          toast.error(err.response.data.errorMessage);
        } else {
          toast.error('Confirm Request Failed. Please try again.');
        }
      })
      .finally(() => {
        // Handle Final (mainly for spinners)
      });
  };

  // rest of your component

  const submitCancelModal = (
    reason,
    remarks,
    cancellationFee,
    subCancelReason,
    cancelReasonId
  ) => {
    console.log({requestData, requestId },"sssss");
    if (!requestId || !reason) {
      console.error({ requestId, reason }, 'No request id present');
      toast.error('Select a reason to continue');
      return;
    }
    if (requestData.cancelledAt) {
      toast.error(`Cancelled Appointment can't be allow to cancel`);
      return Promise.resolve(false);
    }
    return cancelRequest(
      requestId,
      reason,
      remarks,
      cancellationFee,
      subCancelReason,
      requestData.prebookedAppointment ? 'cancelled' : null,
      cancelReasonId
    )
      .then((response) => {
        // Handle success response
        toast.success('Cancel Request Success');
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.errorMessage) {
          toast.error(err.response.data.errorMessage);
        } else {
          toast.error('Cancel Request fail Please try again');
        }
      })
      .finally(() => {
        // Handle Final (mainly for spinners)
      });
  };

  const shiftSelfbookAppointment = async (requestData, rescheduleDate, rescheduleTime, shiftAndConfirm = true, selfBook = true) => {
    setShiftSelfbookLoader(true);
    console.log({ requestData, rescheduleDate, rescheduleTime ,shiftAndConfirm, selfBook}, 'shiftSelfbookAppointment');
    if (!requestData || !rescheduleDate || !rescheduleTime) {
      console.error({ requestId, rescheduleDate, rescheduleTime }, 'Params missing');
      setShiftSelfbookLoader(false);
      return;
    }
    const doctorId = doctorsData.value;
    const centerId = doctorsData.centerId;
    if (!doctorId || !centerId || !rescheduleDate || !rescheduleTime) {
        toast.error('Incorrect Selection');
        setShiftSelfbookLoader(false);
        return;
    }
    try {
      const shiftResponse = await shiftAppointment(
        requestId,
        doctorId,
        centerId,
        null,
        null,
        rescheduleDate,
        rescheduleTime,
        'fixed',
        null,
        null,
        shiftAndConfirm,
        null,
        selfBook
      );
      if (shiftResponse && shiftResponse.data && shiftResponse.data.message === 'serverError') {
        toast.error(shiftResponse.data.errorMessage);
        return;
      }
      if (shiftAndConfirm) {
        try {
          // Call confirmRequest after shiftAppointment
          await confirmRequest(
            requestId,
            rescheduleDate,
            rescheduleTime,
            false,
            'fixed',
            null,
            shiftAndConfirm,
            selfBook
          );
          toast.success('Appointment shifted and confirmed successfully');
        } catch (error) {
          console.error('Error in confirmRequest:', error);
          toast.error('Appointment shifted, but confirmation failed');
          setShiftSelfbookLoader(false);
          return;
        }
      } else {
        toast.success('Shift Selfbook Appointment Success');
        getOfflineRequestData()
      }
    } catch (err) {
      if (err.response?.data?.errorMessage) {
        toast.error(err.response.data.errorMessage);
      } else {
        toast.error('Shift Selfbook Appointment Failed. Please try again.');
      }
      setShiftSelfbookLoader(false);
    } finally {
      // Handle Final (mainly for spinners)
      setSelfbookShiftingModalOpen(false);
      getOfflineRequestData()
    }
  };
  return (
    <>
      {featureA && ((statusFilter === 'prebooked_appointment' || tagsFilter === 'prebookedAppointments' || (requestData && requestData.prebookedAppointment)
 ) ? (
        <div className="d-flex flex-col">
          <div className="flex flex-row justify-center">
          { requestData && !requestData.cashlessLetterLink && ((requestData.platform == 'IOS' && requestData.version > 740) || (requestData.platform == 'ANDROID' && requestData.version > 1800009640) || (requestData.platform == 'WEB') || !requestData.version )  && !requestData.cancelledAt && (<> 
          <UncontrolledTooltip target={`userConfirmedButton-${requestId}`}>
              User Confirmed
            </UncontrolledTooltip>
            <img
              id={`userConfirmedButton-${requestId}`}
              onClick={() => togglePrebookUserConfirmModal(requestData)}
              src={PrebookUserConfirm}
              alt="User Confirmed Button"
              className="button-img"
              style={{ width: '24px', height: '24px', cursor: 'pointer' }}
            />
            </>)}
            { requestData && !requestData.cashlessLetterLink && ((requestData.platform == 'IOS' && requestData.version > 740) || (requestData.platform == 'ANDROID' && requestData.version > 1800009640) || (requestData.platform == 'WEB') || !requestData.version ) && requestData.center_type == 'prepaid' && !requestData.cancelledAt && (<> 
            <UncontrolledTooltip target={`userCenterConfirmedButton-${requestId}`}>
              User and Center Confirmed
            </UncontrolledTooltip>
            <img
              id={`userCenterConfirmedButton-${requestId}`}
              onClick={() => togglePrebookCenterConfirmModal(requestData)}
              src={PrebookCenterConfirm}
              alt="User and Center Confirmed Button"
              className="button-img"
              style={{ width: '24px', height: '24px', cursor: 'pointer' }}
            />
             </>)}
             { requestData && (requestData.center_type != 'prepaid'|| (requestData.center_type == 'prepaid' && !requestData.cashlessLetterLink)) && (<> 
            <UncontrolledTooltip target={`cancelButton-${requestId}`}>
              Cancel Appointment
            </UncontrolledTooltip>
            <img
              id={`cancelButton-${requestId}`}
              onClick={() => cancelOpenModal(requestId, priceApprovalStatus)}
              src={CrossButton}
              alt="Cross Button"
              className="button-img"
              style={{ width: '24px', height: '24px', cursor: 'pointer' }}
            />
            </>)}
            <UncontrolledTooltip target={`rescheduleButton-${requestId}`}>
              Reschedule SelfBook Appointment
            </UncontrolledTooltip>
            <img
              id={`rescheduleButton-${requestId}`}
              onClick={() => toggleSelfbookShiftingModal(requestData)}
              src={TimerButton}
              alt="Cross Button"
              className="button-img"
              style={{ width: '24px', height: '24px', cursor: 'pointer' }}
            />
            </div>
        </div>
      ) : (
        
            <div className="d-flex flex-col">
          <div className="flex flex-row justify-center">
            <UncontrolledTooltip target={`confirmButton-${requestId}`}>
              Confirm Appointment
            </UncontrolledTooltip>
            <img
              src={TickButton}
              alt="Tick Button"
              className="button-img"
              style={{ width: '24px', height: '24px', cursor: 'pointer' }}
              id={`confirmButton-${requestId}`}
              onClick={() =>
                confirmOpenModal(requestId, priceApprovalStatus, requestData)
              }
            /> 
            <UncontrolledTooltip target={`cancelButton-${requestId}`}>
              Cancel Appointment
            </UncontrolledTooltip>
            <img
              id={`cancelButton-${requestId}`}
              onClick={() => cancelOpenModal(requestId, priceApprovalStatus)}
              src={CrossButton}
              alt="Cross Button"
              className="button-img"
                style={{ width: '24px', height: '24px', cursor: 'pointer' }}
              />
              <UncontrolledTooltip target={`transferButton-${requestId}`}>
                Reschedule Request
              </UncontrolledTooltip>
              <img
                src={TimerButton}
                alt="Reschedule Button"
                className="button-img"
                style={{ width: '24px', height: '24px', cursor: 'pointer' }}
                id={`transferButton-${requestId}`}
                onClick={() => openShiftingModal(requestData)}
              />
              {offlineAdmin && requestData?.externalApiLogsId ? (
                <>
                  <UncontrolledTooltip target={`apiButton-${requestId}`}>
                    Reschedule API Request
                  </UncontrolledTooltip>
                  <img
                    src={ShiftToPending}
                    alt="Reschedule Button"
                    className="button-img"
                    style={{ width: '24px', height: '24px', cursor: 'pointer' }}
                    id={`apiButton-${requestId}`}
                    onClick={() => openApiShiftingModal(requestData)}
                  />
                </>
              ) : null}
              <UncontrolledTooltip target={`requestPriceChanges-${requestId}`}>
                Request Price Changes
              </UncontrolledTooltip>
              <img
                src={PenButton}
                alt="Pen Button"
                className="button-img"
              id={`requestPriceChanges-${requestId}`}
              onClick={() => {
                togglePriceChangeRequest(requestData)
              }}
              style={{ width: '24px', height: '24px', cursor: 'pointer' }}
            />
            {appointmentStatus == 0 ? <><UncontrolledTooltip target={`claimButton-${requestId}`}>
              Claim Request
            </UncontrolledTooltip>
            <img
              id={`claimButton-${requestId}`}
              onClick={() => openClaimRequestButton(requestId)}
              src={ClaimRequest}
              alt="ClaimRequestButton"
              className="button-img"
              style={{ width: '24px', height: '24px', cursor: 'pointer' }}
            /></> : <></>}

            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                // overflow: 'auto',
                position: 'relative',
              }}
            >
              <img
                src={DropDown}
                alt="DropDownButton"
                onClick={() => toggleDropdown(requestId)}
                className="dropdown-toggle"
                style={{
                  width: '24px',
                  height: '24px',
                  cursor: 'pointer',
                  margin: '4px',
                }}
              />
            </div>
          </div>
          <div>
            {isOpen && requestId === openActionDropDown && (
              <div
                className="mt-2"
                style={{
                  position: 'relative',
                  display: 'flex',
                  flexDirection: 'column',
                  flexWrap: 'wrap',
                  width: '220px',
                  border: '1px solid #e9ecef',
                  padding: '10px',
                  borderRadius: '10px',
                  boxShadow: '0px 0px 10px 0px #e9ecef',
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    gap: '5px',
                    borderBottom: '1px solid #F2F1F6',
                  }}
                >
                  <img
                    src={AddAssignee}
                    onClick={() => openAddDoctorDetailModal()}
                    alt="AddAssignee"
                    style={{ width: '24px', height: '24px', cursor: 'pointer' }}
                  />
                  <p>Add Doctor</p>
                </div>

                { !requestData.prebookedAppointment && requestData.externalApiLogsId && !requestData.externalBookingId && !requestData.cancelledAt && (<div
                  style={{
                    display: 'flex',
                    gap: '5px',
                    borderBottom: '1px solid #F2F1F6',
                  }}
                >
                  <img
                    src={ApiBooking}
                    onClick={() => openApiBookingModal(requestData)}
                    alt="Book API Appointment"
                    style={{ width: '24px', height: '24px', cursor: 'pointer' }}
                  />
                  <p>Book API Appointment</p>
                </div> )}

                <div
                  className="mt-2"
                  style={{
                    display: 'flex',
                    width: 'max-content',
                    gap: '5px',
                    borderBottom: '1px solid #F2F1F6',
                  }}
                >
                  <img
                    src={AlternateSuggestions}
                    id={`suggestionsButton-${requestId}`}
                    onClick={() => openSuggestions(requestData)}
                    alt="AlternateSuggestions"
                    style={{ width: '24px', height: '24px', cursor: 'pointer' }}
                  />
                  <p>Alternate suggestions</p>
                </div>
                {/* <div
                    className="mt-2"
                    style={{
                      display: 'flex',
                      width: 'max-content',
                      gap: '5px',
                      borderBottom: '1px solid #F2F1F6',
                    }}
                  >
                    <img
                      src={MarkAsStuck}
                      alt="Mark as Stuck"
                      className="button-img"
                      id={`markAsStuck-${requestId}`}
                      onClick={() => toggleMarkAsStuckModal(requestData)}
                      style={{ width: '24px', height: '24px', cursor: 'pointer', border:'2px solid black' }}
                    />
                  <p>Mark as stuck</p>
                </div> */}
                  <div
                    className="mt-2"
                    style={{
                      display: 'flex',
                      width: 'max-content',
                      gap: '5px',
                      borderBottom: '1px solid #F2F1F6',
                    }}
                  >
                    <img
                      src={Reimbursement}
                      alt="ShiftToReimbursement"
                      id={`shiftToReimbursementButton-${requestId}`}
                      onClick={() => toggleShiftToReimbursementModal(requestId)}
                      style={{ width: '24px', height: '24px', cursor: 'pointer' }}
                    />
                    <p>Shift to reimbursement</p>
                  </div>                  
                {/* <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-around',
                  }}
                >
                  <img
                    src={ShiftToPending}
                    alt="ShiftToPending"
                    style={{ width: '24px', height: '24px', cursor: 'pointer' }}
                  />
                  <p>Request reimbursement</p>
                </div> */}
                <div
                  className="mt-2"
                  style={{
                    display: 'flex',
                    width: 'max-content',
                    gap: '5px',
                    borderBottom: '1px solid #F2F1F6',
                  }}
                >
                  <img
                    src={RequestReconfirmation}
                    alt="RequestReconfirmation"
                    id={`requestReconfirmationButton-${requestId}`}
                    onClick={() => toggleRequestReconfirmationModal(requestId)}
                    style={{ width: '24px', height: '24px', cursor: 'pointer' }}
                  />
                  <p>Request reconfirmation</p>
                </div>
               {offlineAdmin ? <div
                    className="mt-2"
                    style={{
                      display: 'flex',
                      width: 'max-content',
                      gap: '5px',
                      borderBottom: '1px solid #F2F1F6',
                    }}
                  >
                    <img
                      src={Pending}
                      alt="Pen Button"
                      className="button-img"
                      id={`shiftToPending-${requestId}`}
                      onClick={() => toggleShiftToPendingModal(requestData)}
                      style={{ width: '24px', height: '24px', cursor: 'pointer' }}
                    />
                  <p>Shift to Pending</p>
                </div>:<></>}
                <div
                    className="mt-2"
                    style={{
                      display: 'flex',
                      width: 'max-content',
                      gap: '5px',
                      borderBottom: '1px solid #F2F1F6',
                    }}
                  >
                    <img
                      src={Communications}
                      alt="Pen Button"
                      className="button-img"
                      id={`sendCommunication-${requestId}`}
                      onClick={() => openCommunications(requestData)}
                      style={{ width: '24px', height: '24px', cursor: 'pointer' }}
                    />
                  <p>Send Communications</p>
                </div>
                <div
                  className="mt-2"
                  style={{
                    display: 'flex',
                    width: 'max-content',
                    gap: '5px',
                    borderBottom: '1px solid #F2F1F6',
                  }}
                >
                  <img
                    src={GrowthArrow}
                    alt="GrowthArrow"
                    className="button-img"
                    id={`growthArrowButton-${requestId}`}
                    onClick={() => openEscallationModal(requestData)}
                    style={{ width: '24px', height: '24px', cursor: 'pointer' }}
                  />
                  <p>Mark Escalation</p>
                </div>
                <div
                  className="mt-2"
                  style={{
                    display: 'flex',
                    width: 'max-content',
                    gap: '5px',
                    borderBottom: '1px solid #F2F1F6',
                  }}
                >
                  <img
                    src={MarkFollowUp}
                    alt="GrowthArrow"
                    className="button-img"
                    id={`markFollowUpButton-${requestId}`}
                    onClick={() => openFollowUpModal(requestData)}
                    style={{ width: '24px', height: '24px', cursor: 'pointer' }}
                  />
                  <p>Mark Follow Up</p>
                </div>
              </div>
            )}
          </div>
        </div>
      ))}
      {featureB && ( (requestData1 && requestData1.prebookedAppointment) ? (
        <div style={{
              display: 'flex',
            }}>
          { requestData && !requestData.cashlessLetterLink && ((requestData.platform == 'IOS' && requestData.version > 740) || (requestData.platform == 'ANDROID' && requestData.version > 1800009640) || (requestData.platform == 'WEB') || !requestData.version ) && !requestData.cancelledAt && (<> 
          <UncontrolledTooltip target={`userConfirmedButton-${requestId}`}>
              User Confirmed
            </UncontrolledTooltip>
            <img
              id={`userConfirmedButton-${requestId}`}
              onClick={() => togglePrebookUserConfirmModal(requestData)}
              src={PrebookUserConfirm}
              alt="User Confirmed Button"
              className="button-img"
              style={{ width: '24px', height: '24px', cursor: 'pointer' }}
            />
            </>)}
            { requestData && !requestData.cashlessLetterLink && ((requestData.platform == 'IOS' && requestData.version > 740) || (requestData.platform == 'ANDROID' && requestData.version > 1800009640) || (requestData.platform == 'WEB') || !requestData.version ) && requestData.center_type == 'prepaid' && !requestData.cancelledAt && (<> 
            <UncontrolledTooltip target={`userCenterConfirmedButton-${requestId}`}>
              User and Center Confirmed
            </UncontrolledTooltip>
            <img
              id={`userCenterConfirmedButton-${requestId}`}
              onClick={() => togglePrebookCenterConfirmModal(requestData)}
              src={PrebookCenterConfirm}
              alt="User and Center Confirmed Button"
              className="button-img"
              style={{ width: '24px', height: '24px', cursor: 'pointer' }}
            />
             </>)}
            { requestData && (requestData.center_type != 'prepaid' || (requestData.center_type == 'prepaid' && !requestData.cashlessLetterLink)) && (<> 
            <UncontrolledTooltip target={`cancelButton-${requestId}`}>
              Cancel Appointment
            </UncontrolledTooltip>
            <img
              id={`cancelButton-${requestId}`}
              onClick={() => cancelOpenModal(requestId, priceApprovalStatus)}
              src={CrossButton}
              alt="Cross Button"
              className="button-img"
              style={{ width: '24px', height: '24px', cursor: 'pointer' }}
            />
            <UncontrolledTooltip target={`rescheduleButton-${requestId}`}>
              Reschedule Appointment
            </UncontrolledTooltip>
            <img
              id={`rescheduleButton-${requestId}`}
              onClick={() => toggleSelfbookShiftingModal(requestData)}
              src={TimerButton}
              alt="Cross Button"
              className="button-img"
              style={{ width: '24px', height: '24px', cursor: 'pointer' }}
            />
            </>)}
            </div>
      ) : (
        
            <div
          className="flex"
          style={{
            paddingLeft: '12px',
            flexWrap: 'wrap',
          }}
        >
          <UncontrolledTooltip target={`confirmButton-${requestId}`}>
            Confirm Appointment
          </UncontrolledTooltip>
          <img
            src={TickButton}
            alt="Tick Button"
            className="button-img"
            style={{
              width: '24px',
              height: '24px',
              cursor: 'pointer',
            }}
            id={`confirmButton-${requestId}`}
            onClick={() =>
              confirmOpenModal(requestId, priceApprovalStatus, followUpData)
            }
          />
          <UncontrolledTooltip target={`cancelButton-${requestId}`}>
            Cancel Appointment
          </UncontrolledTooltip>
          <img
            id={`cancelButton-${requestId}`}
            onClick={() => cancelOpenModal(requestId, priceApprovalStatus)}
            src={CrossButton}
            alt="Cross Button"
            className="button-img"
            style={{ width: '24px', height: '24px', cursor: 'pointer' }}
          />
          <UncontrolledTooltip target={`transferButton-${requestId}`}>
            Reschedule Request
          </UncontrolledTooltip>
          <img
            src={TimerButton}
            alt="Reschedule Button"
              className="button-img"
              style={{ width: '24px', height: '24px', cursor: 'pointer' }}
              id={`transferButton-${requestId}`}
              onClick={() => openShiftingModal(requestData)}
            />
            {offlineAdmin && requestData?.externalApiLogsId ? (
              <>
                <UncontrolledTooltip target={`apiButton-${requestId}`}>
                  Reschedule API Request
                </UncontrolledTooltip>
                <img
                  src={ShiftToPending}
                  alt="Reschedule Button"
                  className="button-img"
                  style={{ width: '24px', height: '24px', cursor: 'pointer' }}
                  id={`apiButton-${requestId}`}
                  onClick={() => openApiShiftingModal(requestData)}
                />
              </>
            ) : null}
            <UncontrolledTooltip target={`requestPriceChanges-${requestId}`}>
              Request Price Changes
            </UncontrolledTooltip>
            <img
            src={PenButton}
            alt="Pen Button"
            className="button-img"
            id={`requestPriceChanges-${requestId}`}
            onClick={() => {
              togglePriceChangeRequest(requestData1)
            }}
            style={{ width: '24px', height: '24px', cursor: 'pointer' }}
          />
          <UncontrolledTooltip target={`claimButton-${requestId}`}>
            Claim Request
          </UncontrolledTooltip>
          <img
            id={`claimButton-${requestId}`}
            onClick={() => openClaimRequestButton(requestId)}
            src={ClaimRequest}
            alt="ClaimRequestButton"
            className="button-img"
            style={{ width: '24px', height: '24px', cursor: 'pointer' }}
          />
          <img
            src={AddAssignee}
            id={`addAssigneeButton-${requestId}`}
            onClick={() => openAddDoctorDetailModal()}
            className="button-img"
            alt="AddAssignee"
            style={{ width: '24px', height: '24px', cursor: 'pointer' }}
          />
          <UncontrolledTooltip target={`addAssigneeButton-${requestId}`}>
            Add Doctor
          </UncontrolledTooltip>
          <img
            src={AlternateSuggestions}
            id={`suggestionsButton-${requestId}`}
            onClick={() => openSuggestions(requestData)}
            className="button-img"
            alt="AlternateSuggestions"
            style={{ width: '24px', height: '24px', cursor: 'pointer' }}
          />
          <UncontrolledTooltip target={`suggestionsButton-${requestId}`}>
            Alternate Suggestions
          </UncontrolledTooltip>
          <img
            src={MarkAsStuck}
            id={`markAsStuck-${requestId}`}
            onClick={() => toggleMarkAsStuckModal(requestData)}
            className="button-img"
            alt="MarkAsStuck"
            style={{ width: '24px', height: '24px', cursor: 'pointer', border:'2px solid black' }}
          />
          <UncontrolledTooltip target={`markAsStuck-${requestId}`}>
            Mark as Stuck
          </UncontrolledTooltip>
           {offlineAdmin ? <><img
              src={Pending}
              alt="Pen Button"
              className="button-img"
              id={`shiftToPending-${requestId}`}
              onClick={() => toggleShiftToPendingModal(requestData)}
              style={{ width: '24px', height: '24px', cursor: 'pointer' }}
            />
            <UncontrolledTooltip target={`shiftToPending-${requestId}`}>
              Shift to Pending
            </UncontrolledTooltip></>  : <></>}
          <img
            src={Reimbursement}
            alt="ShiftToReimbursement"
            id={`shiftToReimbursementButton-${requestId}`}
            className="button-img"
            onClick={() => toggleShiftToReimbursementModal(requestId)}
            style={{ width: '24px', height: '24px', cursor: 'pointer' }}
          />
          <UncontrolledTooltip
            target={`shiftToReimbursementButton-${requestId}`}
          >
            Shift to Reimbursement
          </UncontrolledTooltip>
            <img
              src={Communications}
              alt="Pen Button"
              className="button-img"
              id={`sendCommunication-${requestId}`}
              onClick={() => openCommunications(followUpData)}
              style={{ width: '24px', height: '24px', cursor: 'pointer' }}
            />
            <UncontrolledTooltip target={`sendCommunication-${requestId}`}>
              Send Communication
            </UncontrolledTooltip>          
          <img
            src={RequestReconfirmation}
            alt="RequestReconfirmation"
            className="button-img"
            id={`requestReconfirmationButton-${requestId}`}
            onClick={() => toggleRequestReconfirmationModal(requestId)}
            style={{ width: '24px', height: '24px', cursor: 'pointer' }}
          />
          <UncontrolledTooltip
            target={`requestReconfirmationButton-${requestId}`}
          >
            Request Reconfirmation
          </UncontrolledTooltip>
          <img
            src={GrowthArrow}
            alt="GrowthArrow"
            className="button-img"
            id={`growthArrowButton-${requestId}`}
            onClick={() => openEscallationModal(requestData)}
            style={{
              width: '24px',
              height: '24px',
              cursor: 'pointer',
            }}
          />
          <UncontrolledTooltip target={`growthArrowButton-${requestId}`}>
            Mark Escallation
          </UncontrolledTooltip>
          <img
            src={MarkFollowUp}
            alt="GrowthArrow"
            className="button-img"
            id={`markFollowUpButton-${requestId}`}
            onClick={() => openFollowUpModal(requestData)}
            style={{ width: '24px', height: '24px', cursor: 'pointer' }}
          />
          <UncontrolledTooltip target={`markFollowUpButton-${requestId}`}>
            Mark FollowUp
          </UncontrolledTooltip>
        </div>
      ))}
      <div>
        <OfflineModalConfirm
          centered
          modalIsOpen={confirmModalIsOpen}
          openModal={confirmOpenModal}
          requestDataForConfirm={requestDataForConfirm}
          closeModal={confirmCloseModal}
          submitModal={submitConfirmModal}
          onComplete={onAction}
          showEditDoctorSlotsModal={editDoctorSlots}
          showEditDoctorSlots={showEditDoctorSlots}
          doctorId={doctorId}
          requestId={requestId}
        />
        <OfflineModalCancel
          centered
          modalIsOpen={cancelModalIsOpen}
          openModal={cancelOpenModal}
          closeModal={cancelCloseModal}
          submitModal={submitCancelModal}
          onComplete={onAction}
          requestId={requestId}
          cancelledReasons={cancelledReasons}
          subCancelledReasons={subCancelledReasons}
        />
        {claimConfirmRequestModalOpen && <OfflineModalClaimAndConfirm 
          centered
          visible={claimConfirmRequestModalOpen}
          openModal={claimConfirmRequestModalTrue}
          closeModal={claimConfirmRequestModalClose}
          submitModal={submitConfirmModal}
          onComplete={onAction}
          showEditDoctorSlotsModal={editDoctorSlots}
          showEditDoctorSlots={showEditDoctorSlots}
          doctorId={doctorId}
          slotDetailsForClaimandConfirm ={slotDetailsForClaimandConfirm}
        />}
        {shiftingDetails && (
          <RescheduleAppointMentRequest
            isOpen={showShiftingModal}
            closeShiftingModal={() => setShowShiftingModal(false)}
            fetchTableData={getOfflineRequestData}
            shiftingDetails={shiftingDetails}
            showEditDoctorSlotsModal={editDoctorSlots}
            showEditDoctorSlots={showEditDoctorSlots}
          />
        )}
        {shiftingDetails && showApiShiftingModal && (
          <RescheduleAppointmentForApiHospitals
            isOpen={showApiShiftingModal}
            closeShiftingModal={() => setShowApiShiftingModal(false)}
            fetchTableData={getOfflineRequestData}
            shiftingDetails={shiftingDetails}
            showEditDoctorSlotsModal={editDoctorSlots}
            showEditDoctorSlots={showEditDoctorSlots}
          />
        )}
        <div>
          <ClaimRequestModal
            onClose={onClaimRequestModalClose}
            isOpen={showClaimRequestModal}
            requestId={showClaimRequestModalRequestId}
          />
        </div>
        { showApiBookingModal && (
          <OfflineApiBookingModal
            isOpen={showApiBookingModal}
            closeShiftingModal={() => setShowApiBookingModal(false)}
            requestDetails={shiftingDetails}
          />
        )}
        <div>
          <StuckReuestModal
            onClose={onStuckRequestModalClose}
            isOpen={markAsStuckModalOpen}
            requestId={markAsStuckRequestId}
          />
        </div>
        <div>
          {addDoctorDetailModalOpen && (
            <AddDoctorDetailModal
              centered
              isOpen={addDoctorDetailModalOpen}
              closeAddDoctorDetailModal={closeAddDoctorDetailModal}
              getOfflineRequestData={getOfflineRequestData}
              onComplete={onAction}
              followUpDetails={followUpDetails}
            />
          )}
        </div>
        <div>
        <div>
          {openComms && (
            <CommunicationsSetup
              closeModal={closeCommunications}
              isOpen={openComms}
              commsData={commsData}
             />
          )}
        </div>
          {showEscallationModal && (
            <MarkEscallationModal
              isOpen={showEscallationModal}
              closeEscallationModal={closeEscallationModal}
              getAllOfflineRequests={getAllOfflineRequests}
              onComplete={onAction}
              requestId={escallationRequestId}
              //followUpDetails={followUpDetails}
            />
          )}
        </div>
        <div>
          {showFollowUpModal && (
            <FollowUpModal
              isOpen={showFollowUpModal}
              closeFollowUpModal={closeFollowUpModal}
              getAllOfflineRequests={getAllOfflineRequests}
              onComplete={onAction}
              followUpDetails={followUpDetails}
            />
          )}
        </div>
        <div>
          <SuggestionsDialog
            suggestionsDetails={suggestionsDetails}
            isOpen={showSuggestions}
            closeSuggestions={closeSuggestions}
          />
        </div>
        <div>
        {prebookUserConfirmModalOpen && (
            <PrebookUserConfirmedModal
              isOpen={prebookUserConfirmModalOpen}
              closePrebookUserConfirmModal={closePrebookUserConfirmModal}
              prebookRequestDetails={prebookRequestDetails}
              onComplete={onAction}
            />
          )}
        </div>
        <div>
        {prebookCenterConfirmModalOpen && (
            <PrebookCenterConfirmedModal
              isOpen={prebookCenterConfirmModalOpen}
              closePrebookCenterConfirmModal={closePrebookCenterConfirmModal}
              prebookRequestDetails={prebookRequestDetails}
              onComplete={onAction}
            />
          )}
        </div>
        <div>
          <Modal
            centered
            isOpen={shiftReimbursementModalOpen}
            toggle={toggleShiftToReimbursementModal}
          >
            <ModalHeader
              className="revamp-modal-header"
              toggle={toggleShiftToReimbursementModal}
            >
              Shift to Reimbursement
            </ModalHeader>
            <ModalBody
              style={{
                fontSize: '16px',
                fontWeight: '500',
              }}
            >
              Are you sure you want to shift this appointment to reimbursement?
              <Row
                style={{
                  padding: '10px',
                }}
              >
                <Col
                  style={{
                    fontSize: '16px',
                    fontWeight: '500',
                  }}
                >
                  Request Id:{' '}
                </Col>
                <Col
                  style={{
                    border: '1px solid #e9ecef',
                    borderRadius: '10px',
                    marginRight: '260px',
                  }}
                >
                  {shiftToReimbursementReqId}
                </Col>
              </Row>
            </ModalBody>
            <ModalFooter
              style={{
                display: 'flex',
                justifyContent: 'center',
              }}
            >
              {loading ? (
                <LoadingComponent />
              ) : (
                <Button
                  justifyContent="center"
                  type="submit"
                  style={{
                    backgroundColor: 'rgb(113, 79, 255)',
                    width: '40%',
                    borderColor: 'rgb(113, 79, 255)',
                    height: '44px',
                  }}
                  onClick={() =>
                    shiftAppointmentToReimbursement(shiftToReimbursementReqId)
                  }
                >
                  Confirm
                </Button>
              )}
            </ModalFooter>
          </Modal>
        </div>
        <div>
          <Modal
            centered
            isOpen={requestReconfirmationModalOpen}
            toggle={toggleRequestReconfirmationModal}
          >
            <ModalHeader
              className="revamp-modal-header"
              toggle={toggleRequestReconfirmationModal}
            >
              {`Request Reconfirmation (Request Id: ${requestReconfirmationRequestId})`}
            </ModalHeader>
            <ModalBody
              style={{
                display: 'flex',
                justifyContent: 'center',
              }}
            >
              {loading ? (
                <LoadingComponent />
              ) : (
                <Button
                  justifyContent="center"
                  type="submit"
                  style={{
                    backgroundColor: 'rgb(113, 79, 255)',
                    width: '40%',
                    borderColor: 'rgb(113, 79, 255)',
                    height: '44px',
                  }}
                  size="sm"
                  onClick={() =>
                    requestReconfirmationForConsultation(
                      requestReconfirmationRequestId
                    )
                  }
                >
                  Confirm
                </Button>
              )}
            </ModalBody>
          </Modal>
        </div>
      </div>
      <div>
        <Modal
          isOpen={priceChangeRequestsModal}
          toggle={togglePriceChangeRequest}
          centered
        >
          <ModalHeader
            className="revamp-modal-header"
            toggle={togglePriceChangeRequest}
          >
            {`Price Change Request`}
          </ModalHeader>
          <ModalBody>
            {requestIdDataForPriceChange && (
              <>
                <FormGroup>
                  <Row>
                    <Col className="col-3">Doctor Id :</Col>
                    <Col>{requestIdDataForPriceChange?.doctorId}</Col>
                  </Row>
                  <Row>
                    <Col className="col-3">Doctor Name :</Col>
                    <Col>{requestIdDataForPriceChange?.doctorName}</Col>
                  </Row>
                  <Row>
                    <Col className="col-3">Center Id :</Col>
                    <Col>{requestIdDataForPriceChange?.networkCenterId}</Col>
                  </Row>
                  <Row>
                    <Col className="col-3">Center Name :</Col>
                    <Col>{requestIdDataForPriceChange?.networkCenterName}</Col>
                  </Row>
                  <Row>
                    <Col className="col-3">Previous Price :</Col>
                    <Col>
                      {requestIdDataForPriceChange?.lastPrice
                        ? requestIdDataForPriceChange.lastPrice
                        : 'Not Available'}
                    </Col>
                  </Row>
                </FormGroup>
              </>
            )}
            <FormGroup>
              <Row>
                <Col className="col-3">Select Reason :</Col>
                <Col>
                  <Select
                    style={{ width: '70%', height: '44px' }}
                    defaultValue="Select Reason"
                    onChange={(e) => setPriceChangeReason(e)}
                  >
                    <Option value="Fee got revised">Fee got revised</Option>
                    <Option value="Incorrect fee was updated in our system">
                      Incorrect fee was updated in our system
                    </Option>
                    <Option value="Incorrect price was informed by the centre while booking the appointment">
                      Incorrect price was informed by the centre while booking
                      the appointment
                    </Option>
                    <Option value="Other">Other</Option>
                  </Select>
                </Col>
              </Row>
              <Row>
                <Col className="col-3">New Prices:</Col>
                <Col>
                  <InputBox
                    style={{ width: '70%' }}
                    type={'number'}
                    value={newPrice}
                    placeholder="Please enter new Prices for offline consultations"
                    onChange={(e) => setNewPrice(e.target.value)}
                  />
                </Col>
              </Row>
            </FormGroup>

            {priceChangeReason === 'Other' && (
              <InputBox
                type={'text'}
                value={inputReason}
                placeholder="Please enter reason for Price Change"
                onChange={(e) => setInputReason(e.target.value)}
              />
            )}
            {loading ? (
              <LoadingComponent />
            ) : (
              <>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-around',
                    paddingTop: '20px',
                  }}
                >
                  <Button
                    type="submit"
                    size="sm"
                    style={{
                      backgroundColor: '#714FFF',
                      width: '40%',
                      borderColor: '#714FFF',
                      height: '44px',
                    }}
                    onClick={() => sendPriceChangeRequest()}
                    disabled={
                      !newPrice ||
                      !priceChangeReason ||
                      (priceChangeReason === 'Other' && !inputReason)
                    }
                  >
                    Send for Approval
                  </Button>

                  <Button
                    type="submit"
                    size="sm"
                    style={{
                      backgroundColor: '#FFFFFF',
                      width: '40%',
                      borderColor: '#714FFF',
                      color: '#714FFF',
                      height: '44px',
                    }}
                    onClick={togglePriceChangeRequest}
                  >
                    Cancel
                  </Button>
                </div>
              </>
            )}
          </ModalBody>
        </Modal>
      </div>
      <div>
      <Modal
          isOpen={shiftToPendingModalOpen}
          toggle={toggleShiftToPendingModal}
        >
          <ModalHeader
            className="revamp-modal-header"
            toggle={toggleShiftToPendingModal}
          >
            {`Shift to pending (Request Id: ${shiftToPendingRequestId})`}
          </ModalHeader>
          <ModalBody style={{
                display: 'flex',
                justifyContent: 'center',
              }}>
            {loading ? (
              <LoadingComponent />
            ) : (
              <Button
                justifyContent="center"
                  type="submit"
                  style={{
                    backgroundColor: 'rgb(113, 79, 255)',
                    width: '40%',
                    borderColor: 'rgb(113, 79, 255)',
                    height: '44px',
                  }}
                onClick={() =>
                 shiftAppointmentToPending(
                    shiftToPendingRequestId
                  )
                }
              >
                Confirm
              </Button>
            )}
          </ModalBody>
        </Modal>
      </div>
      <div>
      <Modal
        centered
        isOpen={selfbookShiftingModalOpen}
        toggle={toggleSelfbookShiftingModal}
      >
      <ModalHeader
        className="revamp-modal-header"
        toggle={toggleSelfbookShiftingModal}
      >
        Reschedule Selfbooked Appointment
      </ModalHeader>
      <ModalBody
        style={{
          fontSize: '16px',
          fontWeight: '500',
        }}
      >
        <div style={{ width: '100%' }}>
          <Row style={{ alignItems: 'center', marginBottom: 16 }}>
            <Col xs="4" style={{ textAlign: 'right' }}>
                <Label
                  style={{
                    fontFamily: 'Inter, sans-serif',
                    fontWeight: '500',
                    width: 'max-content',
                  }}
                >
                  Search Doctor:
                </Label>
              </Col>
            <Col xs="8">
                <Async
                  loadOptions={searchDoctor}
                  onChange={(e) => {
                    handleDoctorSelection(e);
                  }}
                  value={doctorsData}
                />
              </Col>
          </Row>
          <Row style={{ alignItems: 'center', marginBottom: 16 }}>
            <Col xs="4" style={{ textAlign: 'right' }}>
              <label style={{ fontWeight: 500, marginBottom: 0, display: 'block' }}>
                Select Date
              </label>
            </Col>
            <Col xs="8">
            <DatePicker
              style={{ width: '100%' }}
              onChange={(date) => setRescheduleDate(date ? moment(date).format('YYYYMMDD') : null)}
              placeholder="Select date"
            />
            </Col>
          </Row>
          <Row style={{ alignItems: 'center' }}>
            <Col xs="4" style={{ textAlign: 'right' }}>
              <label style={{ fontWeight: 500, marginBottom: 0, display: 'block' }}>
                Select Time
              </label>
            </Col>
            <Col xs="8">
              <DatePicker.TimePicker
                style={{ width: '100%' }}
                onChange={(time) => setRescheduleTime(time ? time.format('hh:mm:00 A') : null)}
                placeholder="Select time"
                format="hh:mm:00 A"
              />
            </Col>
          </Row>
        </div>
      </ModalBody>
      <ModalFooter
        style={{
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        {shifSelfbookLoader ? (
          <LoadingComponent />
        ) : (
          <Button
            justifyContent="center"
            type="submit"
            style={{
              backgroundColor: 'rgb(113, 79, 255)',
              width: '40%',
              borderColor: 'rgb(113, 79, 255)',
              height: '44px',
            }}
            onClick={() => shiftSelfbookAppointment(requestData, rescheduleDate, rescheduleTime)}
          >
            Confirm
          </Button>
        )}
      </ModalFooter>
      </Modal>
      </div>
    </>
  );
};

export default Actions;
